// src/components/common/PageHeader.tsx
import React from "react";
import {
  Typography,
  Box,
  Breadcrumbs,
  Link as MuiLink,
  Paper,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  title: string;
  breadcrumbs?: BreadcrumbItem[];
  action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  breadcrumbs,
  action,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        borderRadius: 2,
        background: "transparent",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "center" },
        gap: { xs: 2, md: 0 },
      }}
    >
      <Box>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 1 }}
          >
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1;

              return isLast || !crumb.path ? (
                <Typography key={index} color="text.primary" variant="body2">
                  {crumb.label}
                </Typography>
              ) : (
                <MuiLink
                  key={index}
                  component={RouterLink}
                  to={crumb.path}
                  color="inherit"
                  underline="hover"
                  variant="body2"
                >
                  {crumb.label}
                </MuiLink>
              );
            })}
          </Breadcrumbs>
        )}
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ color: "text.primary" }}
        >
          {title}
        </Typography>
      </Box>

      {action && <Box sx={{ mt: { xs: 1, md: 0 } }}>{action}</Box>}
    </Paper>
  );
};

export default PageHeader;
